//third party

import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "../material.module";
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { RichTextEditorModule } from './rich-text-editor/rich-text-editor.module';

import { PipesModule } from "../pipes/pipes.module";
import { ChartsModule } from "./charts/charts.module";
import { GraphQlModule } from "./GraphQL/graphql.module";


import { CradleToGravePopUpComponent } from "./cradle-to-grave-pop-up/cradle-to-grave-pop-up.component";
import { CradleToGraveComponent } from "./cradle-to-grave/cradle-to-grave.component";
import { DatePickerComponent } from "./date-picker/date-picker.component";
import { DialogComponent } from "./dialog/dialog.component";
import { EveCdrDataTableComponent } from "./evecdr-datatable/evecdr-datatable.component";

import { LeaderboardComponent } from "./leaderboard/leaderboard.component";
import { UserPopUpComponent } from "./user-pop-up/user-pop-up.component";
import { FunctionNumberPopUpComponent } from "./function-number-pop-up/function-number-pop-up.component";
import { TelepoCdrDataTableComponent } from "./telepocdr-datatable/telepocdr-datatable.component";
import { WidgetsModule } from "./widgets/widgets.module";
import { CompaniesAutoCompleteComponent } from "./autocompletes/companies-autocomplete/companies-autocomplete.component";
import { AutoCompleteModule } from "primeng/autocomplete";
import { DirectivesModule } from "../directives/directives.module";





@NgModule({
  exports: [
    CradleToGraveComponent,
    CradleToGravePopUpComponent,
    DatePickerComponent,
    DialogComponent,
    EveCdrDataTableComponent,
    TelepoCdrDataTableComponent,
    LeaderboardComponent,
    UserPopUpComponent,
    FunctionNumberPopUpComponent,
    CompaniesAutoCompleteComponent,


    CommonModule,
    MaterialModule,
    ChartsModule,
    WidgetsModule,
    GraphQlModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,

    AutoCompleteModule
  ],
  declarations: [
    CradleToGraveComponent,
    CradleToGravePopUpComponent,
    DatePickerComponent,
    DialogComponent,
    EveCdrDataTableComponent,
    TelepoCdrDataTableComponent,
    LeaderboardComponent,
    UserPopUpComponent,
    FunctionNumberPopUpComponent,
    CompaniesAutoCompleteComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ChartsModule,
    GraphQlModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    NgxMaterialTimepickerModule,
    WidgetsModule,
    RichTextEditorModule,
    AutoCompleteModule,
    DirectivesModule
  ]
})
export class ComponentsModule { }
